import type { GasVolumeCompressibilityCalculator } from "../d";

export const poettmanCompressibilityCalculator: GasVolumeCompressibilityCalculator =
  params => {
    const {
      psuedoCriticals: { psuedoReducedPressure, psuedoReducedTemperature }
    } = params;

    // D48: =I48+I49*(1+I50*D35+I51*D35^2+I52*D35^3+I53*D35^4)*D36+I54*D36^2+I55*D36^3+I56*D36^4
    const numerator =
      256.41675 +
      7.18202 *
        (1 +
          -178.5725 * psuedoReducedTemperature +
          182.98704 * psuedoReducedTemperature ** 2 +
          -40.74427 * psuedoReducedTemperature ** 3 +
          2.24427 * psuedoReducedTemperature ** 4) *
        psuedoReducedPressure +
      47.44825 * psuedoReducedPressure ** 2 +
      5.2852 * psuedoReducedPressure ** 3 +
      -0.14914 * psuedoReducedPressure ** 4;

    // D49: =I57+I58*(1+I59*D35+I60*D35^2+I61*D35^3+I62*D35^4+I63*D35^5)*D36+I64*D36^2+I65*D36^3+I66*D36^4+I67*D36^5
    // this is just for readability
    const polynomial =
      1 +
      -121.51728 * psuedoReducedTemperature +
      167.71477 * psuedoReducedTemperature ** 2 +
      -81.73093 * psuedoReducedTemperature ** 3 +
      20.36191 * psuedoReducedTemperature ** 4 +
      -2.1177 * psuedoReducedTemperature ** 5;

    // this is the actual calculation
    const denominator =
      271.50446 +
      16.2694 * polynomial * psuedoReducedPressure +
      124.64444 * psuedoReducedPressure ** 2 +
      -6.74331 * psuedoReducedPressure ** 3 +
      0.20897 * psuedoReducedPressure ** 4 +
      -0.00314 * psuedoReducedPressure ** 5;

    // D51: =D48/D49
    const gasCompressibilityFactor = denominator ? numerator / denominator : 0;

    return {
      gasCompressibilityFactor,
      intermediates: {
        numerator,
        denominator,
        polynomial,
        psuedoReducedTemperature,
        psuedoReducedPressure
      }
    };
  };
